import { AuthByEmailRequestDto as AuthByEmailRequestModel } from '@goparrot/dashboard-gateway-sdk';

(AuthByEmailRequestModel as any).prototype.init = function (options: Partial<AuthByEmailRequestModel> = {}) {
  this.email = options?.email ?? '';
  this.password = options?.password ?? '';
  return this;
};

export { AuthByEmailRequestModel };
